import * as React from "react";
import { cn } from "~/lib/utils";
import { BottomSheetContext } from "./context";

type BottomSheetBodyProps = React.HTMLAttributes<HTMLDivElement>;

export const BottomSheetBody = React.forwardRef<HTMLDivElement, BottomSheetBodyProps>(
  ({ className, ...props }, ref) => {
    const context = React.useContext(BottomSheetContext);
    const isOpen = context?.step === "open";

    return (
      <div
        ref={ref}
        data-slot="bottom-sheet-body"
        className={cn(
          "flex-1 min-h-0",
          { "overflow-y-auto overscroll-y-contain": isOpen, "overflow-hidden": !isOpen },
          className,
        )}
        {...props}
      />
    );
  },
);

BottomSheetBody.displayName = "BottomSheetBody";
